import { render } from "./index.vue?vue&type=template&id=cf84a590&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=cf84a590&lang=scss&scoped=true"

import exportComponent from "F:\\Hongjia\\RedCigar_C_T_Template\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf84a590"]])

export default __exports__